import { createContext, useContext, useState, useEffect } from 'react';

const SmileAuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function SmileAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('smile_app_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('smile_app_user');
    if (stored && token) {
      try { setUser(JSON.parse(stored)); } catch { localStorage.removeItem('smile_app_user'); }
    }
    setLoading(false);
  }, [token]);

  const login = async (email, password) => {
    const res = await fetch(`${API_URL}/api/smile-app/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (data.error === 'registration_required') return data;
    if (!res.ok) throw new Error(data.detail || 'Login failed');
    localStorage.setItem('smile_app_token', data.token);
    localStorage.setItem('smile_app_user', JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data;
  };

  const setAuth = (newToken, newUser) => {
    localStorage.setItem('smile_app_token', newToken);
    localStorage.setItem('smile_app_user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  };

  const logout = () => {
    localStorage.removeItem('smile_app_token');
    localStorage.removeItem('smile_app_user');
    setToken(null);
    setUser(null);
  };

  const authFetch = async (url, options = {}) => {
    const headers = { ...options.headers, 'Authorization': `Bearer ${token}` };
    if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json';
    return fetch(url, { ...options, headers });
  };

  return (
    <SmileAuthContext.Provider value={{ user, token, loading, login, setAuth, logout, authFetch }}>
      {children}
    </SmileAuthContext.Provider>
  );
}

export function useSmileAuth() {
  const ctx = useContext(SmileAuthContext);
  if (!ctx) throw new Error('useSmileAuth must be inside SmileAuthProvider');
  return ctx;
}
